import './style.css'

function RecuperaLogin() {
    return (
        <h1>Recupera senha</h1>
    )
}

export default RecuperaLogin;